import React, {useCallback, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Card from "../../../components/card";
import Button from "../../../components/button";
import TemplateDefault from "../../../components/template-default";
import SelectComponent from "../../../components/select-component";
import {typeList} from "../resources/typeList";
import InputForm from "../../../components/input-form";
import InputText from "../../../components/input-text";
import InputCheckbox from "../../../components/input-checkbox";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import IntegrationsService from "../../../services/integrations-service";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import MySwal from "sweetalert2";
import requestService from "../../../services/request-service";
import integrationsService from "../../../services/integrations-service";
import {FaPlus} from "react-icons/fa";

const BASENAME = process.env.PUBLIC_URL;

const  initialState = {
    request_id: "",
    type: "",
    name: "",
    gitlab: "",
    conclude: false,
    description: ""
}
const IntegrationForm = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(initialState);
    const [relatedIntegration, setRelatedIntegration] = useState([])
    const [integration, setIntegration] = useState('')
    const [requestsIds, setRequestsIds] = useState([])

    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const handleSelect = (value, name) => setState(prev => ({...prev, [name]: value}));
    const handleInput = ({target: {name, value}}) => setState(prev => ({...prev, [name]: value}));

    useQuery({
        queryFn: () => IntegrationsService.getById(id).then((data) => {
            setState(data)
            return data
        }),
        queryKey: ['state', { id }],
        enabled: !!id,
    });

    useQuery({
        queryFn: () => integrationsService.listRequests(id, 'integration').then(({data}) => setRelatedIntegration(data)),
        queryKey: ['associatedIntegration']
    })

    useQuery({
        queryFn: () => requestService.getRequestsIds().then(({data}) => setRequestsIds(data)),
        queryKey: ['requestsIds']
    })
    const submit = () => {
        setIsLoading(true);

        const formData = new FormData();

        const form = {
            ...state,
            request_id: state.request_id ?? "",
            type: state.type?.value ? state.type?.value : state.type,
            name: state.name ?? "",
            gitlab: state.gitlab ?? "",
            conclude: state.conclude ?? "",
            description: state.description ?? "",
            relatedIntegration: relatedIntegration ? JSON.stringify(relatedIntegration) : "",
        }

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        if (!!id) formData.append('_method', 'PUT');

        const response = !!id ? IntegrationsService.edit(formData, id) : IntegrationsService.create(formData);

        response
            .then(({ data }) => {
                toast.success("Salvo com sucesso.");
                navigate(`/integrations/form/${data.id}`);
            })
            .catch((err) => {
                const { data: { message } } = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
            .finally(() => {
                queryClient.invalidateQueries('associatedIntegration')
                queryClient.invalidateQueries('requestsIds')
                setIsLoading(false)
            });
    }

    const deleteIntegration = () => {
        MySwal.fire({
            icon: "warning",
            title: "Excluir!",
            showCancelButton: true,
            text: "Tem certeza que deseja excluir a integração?",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: '#e64942',
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setIsLoading(true);

                IntegrationsService.delete(id)
                    .then(() => {
                        navigate(`/integrations`);
                    })
                    .catch((err) => {
                        const {data: {message}} = err.response;
                        toast.error(AlertMessage[message] ?? "Não foi possível excluir");
                    })
                    .finally(() => setIsLoading(false));
            }
        });
    }

    const deleteRequest = (integration_id) => {
        const localId = String(integration_id);
        if (localId.includes("uuid-")){
            setRelatedIntegration((prev) => prev.filter((item) =>  item.id !== integration_id));
        }else{
            IntegrationsService.deleteAssociatedIntegration(integration_id)
                .catch((err) => {
                    const {data: {message}} = err.response;
                    toast.error(AlertMessage[message] ?? "Não foi possível excluir");
                }).then(setRelatedIntegration((prev) => prev.filter((item) =>  item.id !== integration_id)))
        }
    }

    const addRelatedRequest = useCallback(() => {
        if (!integration){
            toast.error(AlertMessage.generalEmpty);
            return
        }

        let duplicate = false
        relatedIntegration.map(r => {
            if(r.associated_integration_id === integration || r.request_id === integration) return duplicate = true;

            return r
        })

        let notExists = false

        if(!requestsIds.some(item => item.id === integration))  notExists = true;

        if (!duplicate && !notExists){
            setRelatedIntegration(prev => ([...prev, {
                id: "uuid-" + integration,
                request_id: integration,
                associated_integration_id: id
            }]))
            setIntegration("")
        }else{
            if (duplicate) toast.error(AlertMessage.duplicateRelation)
            if (notExists) toast.error(AlertMessage.notExistIntegration)
        }

    }, [id, integration, relatedIntegration, requestsIds, setRelatedIntegration]);

    const openRequest = (requestId) => {
        window.open(`${BASENAME}/requests/form/${requestId}`);
    }

    return (
        <TemplateDefault title={"Nova Integração"} isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-2 gap-y-4 lg:grid-cols-12">
                    <div className="col-span-12 lg:col-span-3 text-gray-900">
                        <SelectComponent
                            instanceId="type"
                            label="Tipo"
                            options={typeList}
                            value={state.type}
                            onChange={(value) => handleSelect(value, "type")}
                        />
                    </div>

                    <InputForm id={"name"} name="name" value={state.name}
                       onChange={handleInput}
                       label="Nome"
                       col="col-span-12 lg:col-span-4"/>

                    <InputForm id={"gitlab"} name="gitlab" value={state.gitlab}
                        onChange={handleInput}
                               label="Gitlab"
                               col="col-span-12 lg:col-span-4"/>

                    <InputCheckbox id={"conclude"} name={"conclude"} label={"Conluída"} col="col-span-12 lg:col-span-1"
                       onChange={({target: {checked}}) => setState(prev => ({
                           ...prev,
                           conclude: checked
                       }))}
                       checked={state.conclude}
                    />

                    <InputForm
                        type={"number"}
                        id="related_integration"
                        label="Solicitação relacionada"
                        value={integration}
                        col="col-span-12 lg:col-span-2"
                        onChange={({ target: { value } }) => setIntegration(value)}
                    />
                    <Button onClick={addRelatedRequest} target="primary" col="col-span-12 lg:col-span-1">
                        <FaPlus />
                    </Button>
                    {relatedIntegration && (
                        <div className={"col-span-9 flex items-center"}>
                            {relatedIntegration.map((r) => (
                                <div key={r.request_id} className="flex items-center">
                                    <p
                                        className={"text-lg hover:text-blue-700 hover:underline cursor-pointer mr-1"}
                                        onClick={() => openRequest(r.request_id)}
                                    >
                                        #{r.request_id}
                                    </p>
                                    <button
                                        className="text-red-500 hover:text-red-700 cursor-pointer mr-2"
                                        onClick={() => deleteRequest(r.id)}
                                    >
                                        X
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <InputText
                        onChange={handleInput}
                        name="description"
                        label="Descrição"
                        col="col-span-12"
                        height={"h-[calc(50vh-230px)]"}
                        value={state.description}
                    />
                </div>


            </Card>

            <Card wrapperClass="mt-3">
                <div className="flex justify-end gap-3">
                    {
                        id &&
                        <Button target="danger" onClick={deleteIntegration}>
                            Excluir
                        </Button>
                    }
                    <Button target="warning" onClick={() => navigate("/integrations")}>
                        Cancelar
                    </Button>
                    <Button target="success" onClick={() => submit()}>
                        Salvar
                    </Button>
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default IntegrationForm;
